import { DecimalPipe } from "@angular/common";
import { Invoice } from "./invoice.model";

interface IConsolidatedInvoice {
    id: string;
    serviceProviderId: string;
    businessName: string;
    name: string;
    monthBilled: number;
    yearBilled: number;
    address: string;
    city: string;
    zipCode: string;
    state: string;
    emailAddress: string;
    primaryPhoneNumber: string;
    totalOwedForMonth: number;
    amountPaid: number;
    paid: boolean;
    amountOwed: string;
    invoices: any[];
}
export class ConsolidatedInvoice {
    public id: string;
    public serviceProviderId: string;
    public businessName: string;
    public name: string;
    public monthBilled: number;
    public yearBilled: number;
    public address: string;
    public city: string;
    public zipCode: string;
    public state: string;
    public emailAddress: string;
    public primaryPhoneNumber: string;
    public totalOwedForMonth: number;
    public paid: boolean;
    public invoices: any[];
    public amountPaid: number;
    public amountOwed: string;

    constructor();
    constructor(object: IConsolidatedInvoice)
    constructor(object?: any) {
        this.id = object && object.id || null;
        this.serviceProviderId = object && object.serviceProviderId || null;
        this.businessName = object && object.businessName || null;
        this.name = object && object.name || null;
        this.monthBilled = object && object.monthBilled || null;
        this.yearBilled = object && object.yearBilled || null;
        this.address = object && object.address || null;
        this.city = object && object.city || null;
        this.zipCode = object && object.zipCode || null;
        this.state = object && object.state || null;
        this.emailAddress = object && object.emailAddress || null;
        this.primaryPhoneNumber = object && object.primaryPhoneNumber || null;
        this.totalOwedForMonth = object && object.totalOwedForMonth || null;
        this.invoices = object && object.invoices || null;
        this.paid = object && object.paid || null;
        this.amountPaid = object && object.amountPaid || null;
        this.amountOwed = object && object.amountOwed || null;
    }
}